import { Injectable } from '@angular/core';

/**
 * Utilidades de dominio NPS. En el original el umbral de color esta en 65:
 * >= 65 verde, < 65 ambar; los netos muy bajos (< 50) se pintan en rojo.
 */
@Injectable({ providedIn: 'root' })
export class NpsService {

  static readonly GOOD_THRESHOLD = 65;
  static readonly BAD_THRESHOLD = 50;

  /** Clase CSS del semaforo para una celda de NPS / CSAT / NETO. */
  colorClass(value: number | null | undefined): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    if (value < NpsService.BAD_THRESHOLD) return 'nps-bad';
    if (value < NpsService.GOOD_THRESHOLD) return 'nps-mid';
    return 'nps-good';
  }
}
